import { Search } from 'lucide-react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

/* the pl-8 override has to stay sm:-prefixed. Input carries its own sm:px-2,
 * which lands in the same media block and otherwise wins on source order,
 * collapsing the icon gutter to 8px and running text under the glyph.
 */
export function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  'aria-label': ariaLabel
}: {
  value: string
  onChange: (value: string) => void
  placeholder: string
  className?: string
  'aria-label': string
}) {
  return (
    <div className={cn('relative', className)}>
      <Search className='pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-ink-muted sm:left-2' />
      <Input
        value={value}
        onChange={event => onChange(event.target.value)}
        onKeyDown={event => {
          if (event.key === 'Enter') event.preventDefault()
        }}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className='pl-9 sm:pl-8'
      />
    </div>
  )
}
